import { TextLink, useTranslation, TextLinkStyle, LinkTarget } from '@nextgen-web-framework/all';
import styles from './ResendOtpLink.module.scss';
import { ResendOtpLinkProps } from './types/propTypes';

const ResendOtpLink = ({ onClick }: ResendOtpLinkProps) => {
  const t = useTranslation();

  return (
    <div className={styles['identity-resend-otp-link']}>
      <TextLink
        data-testid="resend-otp-link"
        text={`${t('identity.VerifyOtp.resendLinkLabel')}`}
        textLinkStyle={TextLinkStyle.UNDERLINE}
        onClick={onClick}
        disabled={false}
        target={LinkTarget.SELF}
      />
    </div>
  );
};

export default ResendOtpLink;
